module.exports = __webpack_public_path__ + "images/enterprise_small3545eaa53ddaafedf4c80dfaf821ebf5.png";